import { styled } from "@mui/material/styles";
import { AccordionSummary } from "@mui/material";
const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  margin: 0,
  padding: 0,
  minHeight: "40px",
  "&.Mui-expanded": {
    minHeight: "30px",
    margin: 0,
  },
  "& .MuiAccordionSummary-content": {
    margin: 0,
  },
}));
export default CustomAccordionSummary;
